<template>
  <div class="md-layout text-center">
    <div
      class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
    >
      <login-card header-color="rose">
        <h4 slot="title" class="title">Log in</h4>
        <md-button
          slot="buttons"
          href="#facebook"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-facebook-square"></i>
        </md-button>
        <md-button
          slot="buttons"
          href="#twitter"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-twitter"></i>
        </md-button>
        <md-button
          slot="buttons"
          href="#google"
          class="md-just-icon md-simple md-white"
        >
          <i class="fab fa-google-plus-g"></i>
        </md-button>
        <p slot="description" class="description">Login</p>

        <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Enter your email</label>
          <md-input
            v-model="loginModel.email"
            type="email"
            class="md-rose"
          ></md-input>
        </md-field>
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>Enter your password</label>
          <md-input v-model="loginModel.password" type="password"></md-input>
        </md-field>
        <md-button
          slot="footer"
          class="md-simple md-primary md-lg"
          @click="enter()"
        >
          Lets Go
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
import axios from "axios";
import auth from "@/services/auth";

export default {
  components: {
    LoginCard
  },
  methods: {
    enter() {
      axios
        .post("api/Auth/Login", {
          Email: this.loginModel.email,
          Password: this.loginModel.password
        })
        .then(response => {
          var token = response.data.Token;

          auth.saveToken(response.data);
          axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

          this.$router.push({ name: "Dashboard" });
        })
        .catch(errors => {
          errors.forEach(error => {
            this.$notify({
              message: error,
              icon: "error_outline",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger"
            });
          });
        });
    }
  },
  data() {
    return {
      loginModel: {
        email: "",
        password: ""
      }
    };
  }
};
</script>

<style></style>
